export const DESTINATION_METRIC_SCHEMA_STORE_KEY = 'destinationMetricSchema';
export const DESTINATION_METRIC_SCHEMA_SERVICE_KEY = 'destinationMetricSchema';
export const DESTINATION_METRIC_SCHEMA_API_URL =
  '/api/v1/metric/schema/destination/';
